import React from "react";

import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import useStyles from "./Maintenance.styles";

const Maintenance = ({ casino = false }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid
      className={classes.staticContainer}
      height={casino ? "calc(100vh - 333px)" : "calc(100vh - 149px)"}
    >
      <Grid className={classes.casinoWrapper}>
        <Typography marginBottom="20px" variant="h5" textAlign="center">
          {casino
            ? t("HOME.CASINO_MAINTENANCE")
            : t("HOME.SPORTSBOOK_MAINTENANCE")}
        </Typography>
        <Typography variant="h6" textAlign="center">
          {t("HOME.BACK_SHORTLY")}
        </Typography>
        <div className={classes.maintenanceImgWrapper}>
          <img alt="" src="/images/maintenance.svg" />
        </div>
      </Grid>
    </Grid>
  );
};

export default Maintenance;
